import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Row, Col } from 'react-flexbox-grid';

import FormSection from 'containers/FormSectionContainer';
import FormField from 'containers/FormField';
import FormProvider from 'routes/Documents/containers/FormProvider';
import InfoField from 'routes/Documents/components/InfoField';

import ScaleField from './ScaleField';
import { nowPartialDate } from 'neuro-utils';

const QualityOfLifeForm = props => {
  // Effect to set 'date' field as current date in partial form when creating a new 15D form
  React.useEffect(() => {
    if (!props.formValues.date && props.editing && Object.keys(props.initialValues).length === 0) {
      props.change('date', nowPartialDate());
    }
  }, []);

  return (
    <FormProvider {...props}>
      <FormSection>
        <InfoField viewStyle={{ marginBottom: '3rem' }}>
          <Row start="sm" center="xs">
            <Col xs={9}>
              <FormattedMessage id="qualityoflife.info" />
            </Col>
          </Row>
        </InfoField>
      </FormSection>
      <FormSection>
        <FormField
          name="sections"
          instrument="qualityoflife"
          component={ScaleField}
          sectionNames={[
            'mobility',
            'vision',
            'hearing',
            'breathing',
            'sleeping',
            'eating',
            'speech',
            'excretion',
            'usualActivities',
            'mentalFunction',
            'discomfortAndSymptoms',
            'depression',
            'distress',
            'vitality',
            'sexualActivity',
          ]}
        />
      </FormSection>
    </FormProvider>
  );
};

export default QualityOfLifeForm;
